<template>
  <div class="layer-manager">
    <div class="layer-manager-title">
      <!-- <p class="overlay-count"> -->
      <span class="layer-manager-visible"
        :class="{ 'icon-glyphicon-eye-open': layerShow, 'icon-glyphicon-eye-close': !layerShow }"
        @click="layerShow = !layerShow"></span>
      <span class="layer-manager-trigger" :class="{ 'icon-icomoon-Shape': fold, 'icon-icomoon-Shape22': !fold }"
        @click="fold = !fold"></span>
      <span class="layers-count">{{ layerList.length }}</span>个图层
      <span class="overlays-count">{{ objectCount }}</span>条记录
      <!-- <span class="layer-recycle" title="回收站">
        <img width="18"
          src="data:image/png;base64,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">
      </span> -->
      <span class="layer-new icon-icomoon-add-layer" title="新建图层" @click="visible = true"></span>
      <!-- </p> -->
    </div>
    <div class="layer-manager-list">

      <LayerCard v-for="(item, index) in layerList" @layer-remove="removeLayer" @object-sum="sumObjectCount"
        @object-reduce="reduceObjectCount" :key="index" :index="index" :item="item" :fold="fold"
        :layerShow="layerShow" />

    </div>

    <el-dialog v-model="visible" :show-close="false" width="500">
      <template #header="{ close, titleId, titleClass }">
        <div class="layer-type-header">
          <h4 :id="titleId" :class="titleClass">新建图层</h4>
          <div class="layer-type-close" @click="close">×</div>
        </div>
      </template>
      <div class="layer-type-context">
        <div class="layer-type-btn" @click="newLayer('0')">
          <img src="@/assets/images/map/create_marker_layer.png" alt="Create marker layer" width="120" height="120">
          <p class="layer-type-btn-text">新建标注图层</p>
        </div>
        <div class="layer-type-btn" @click="newLayer('1')">
          <img src="@/assets/images/map/create_line_layer.png" alt="Create line layer" width="120" height="120">
          <p class="layer-type-btn-text">新建线路图层</p>
        </div>
        <div class="layer-type-btn" @click="newLayer('2')">
          <img src="@/assets/images/map/create_region_layer.png" alt="Create region layer" width="120" height="120">
          <p class="layer-type-btn-text">新建区域图层</p>
        </div>
      </div>
    </el-dialog>
  </div>

</template>

<script>

import LayerCard from '../common/LayerCard.vue';
import { getLayerList, addLayer, getDescriptionInfo} from '@/api/Common';


import { useMapStore } from '@/stores/mapStore';

export default {
  name: 'LayerManager',
  components: {
    LayerCard
  },
  data() {
    return {
      layerList: [],
      mapStore: null,
      visible: false,
      fold: false,
      layerShow: true,
      objectCount: 0,
    }
  },
  mounted() {
    this.mapStore = useMapStore();
    this.mapStore.selectLayer = null;
    if (this.mapStore.getSelectAtlas()) {
      let atlasId = this.mapStore.getSelectAtlas().id;
      this.getLayerList(atlasId);
    }

  },
  methods: {

    //对象数量求和
    sumObjectCount(objectCount) {
      this.objectCount += objectCount;
    },
    //删减对象数量
    reduceObjectCount(objectCount) {
      this.objectCount -= objectCount;
    },
    removeLayer(index) {
      this.layerList.splice(index, 1);
    },
    getLayerList(atlasId) {
      let that = this;
      getLayerList({
        "atlasId": atlasId
      }).then(res => {
        if (res.code == 200) {
          that.layerList = res.rows.filter(item => item.delFlag === '0');
        }
      })

    },
    newLayer(type) {
      let that = this;
      let defaultName = "新图层";
      switch (type) {
        case '0':
          defaultName = "新标注图层";
          break;
        case '1':
          defaultName = "新线图层";
          break;
        case '2':
          defaultName = "新区域图层";
          break;
      }
      addLayer({ "atlasId": this.mapStore.getSelectAtlas().id, "name": defaultName, "type": type }).then(res => {
        if (res.code == 200) {
          that.getLayerList(that.mapStore.getSelectAtlas().id);
        }
      });
      this.visible = false;
    }

  }
}

</script>

<style scoped>
.layer-type-btn {
  cursor: pointer;
  text-align: center;
  width: 120px;
  float: left;
  position: relative;
  min-height: 1px;
  margin: 0px 10px;
}

.layer-type-btn-text {}

.layer-type-context {
  position: relative;
  padding: 50px 0px;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
}



.layer-type-close {
  color: #fff;
  font-size: 26px;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 10px;
}

.layer-type-header {
  position: relative;
  height: 46px;
  padding:
    12px;
  background-color: #1b2d3e;
  color: #fff;
  border-radius:
    5px 5px 0 0;

}

.layer-type-header h4 {
  color: #fff;
}


.layer-manager {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  scrollbar-width: none;
}

.layer-manager-title {
  height: 36px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #edf0f5;
  line-height: 36px;
  color: #576d8b;
}

.layer-manager-visible {
  cursor: pointer;
}

.layer-manager-trigger {
  cursor: pointer;
  margin-left: 5px;
}

.layers-count {
  margin-left: 5px;
}

.overlays-count {
  margin-left: 10px;
}

.layer-recycle {
  cursor: pointer;
  position: absolute;
  right: 50px;
  top: -3px;
  margin-left: 20px;
}

.layer-new {
  font-size: 22px;
  margin-top: 6px;
  cursor: pointer;
  color: #0095ff;
  float: right;
}


.layer-manager-list {
  overflow-y: auto;
  overflow-x: hidden;
  width: 305px;
  height: 95%;
  padding-bottom: 12px;

}
</style>